@if (siteInformations) {
<div class="site-container">
    <div class="title">
        <fa-icon [icon]="faAngleRight"></fa-icon>
        <span>{{ 'Site.Title' | translate }} {{ siteInformations.name ? '"' + siteInformations.name + '"' : siteInformations.id ? '"' + siteInformations.id + '"' : '' }}</span>
    </div>

    <div class="content">
        @if (siteInformations !== undefined) {
        <form [formGroup]="siteForm" (ngSubmit)="onSubmit()">
            <div class="form-content">
                <mat-card appearance="outlined" class="box default-card">
                    <mat-card-content>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'Site.NamePlaceholder' | translate }}</mat-label>
                                <input matInput formControlName="name" autocomplete="off" required />
                            </mat-form-field>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="save-button">
                <button mat-stroked-button color="accent" type="button" routerLink="/sites">{{ 'Site.CancelButton' | translate }}</button>
                <button mat-raised-button color="accent" [disabled]="!siteForm.valid" type="submit">{{ 'Site.SubmitButton' | translate }}</button>
            </div>
        </form>
        }
    </div>
</div>
}
